import {observer} from 'mobx-react';
import React, {CSSProperties} from 'react';

type Props = {
    url: string;
    alt: string;
    border?: boolean;
    backgroundImage?: string;
    imgStyle?: CSSProperties;
};

export const StandardSlide = observer(({url, alt, border, backgroundImage, imgStyle}: Props) => {
    if (!url) {
        return null;
    }

    return (
        <div
            style={{
                width: 75,
                height: 75,
                overflow: 'hidden',
                border: border ? '1px solid silver' : undefined,
                backgroundImage: backgroundImage || undefined,
                backgroundSize: backgroundImage ? 'cover' : undefined,
            }}
        >
            <picture>
                <source
                    type="image/webp"
                    srcSet={url.replace('.png', '.webp').replace('.jpg', '.webp')}
                />
                <img
                    src={url}
                    alt={alt}
                    width={75}
                    height={75}
                    style={{
                        width: 75,
                        height: 75,
                        maxWidth: 75,
                        objectFit: 'contain',
                        ...imgStyle,
                    }}
                />
            </picture>
        </div>
    );
});
